<template>
  <div class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="hasSelectedItems"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-narrow">
            <b-input :placeholder="$t('listeMaterielTlpe.actions.search')" type="search"
              icon="magnify"
              v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('listeMaterielTlpe.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="getFilteredNumber > 0 ? '' : 'is-invisible'">
                  ({{ getFilteredNumber }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <qd-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="code" slot-scope="props">
        <router-link :to="{ name: 'c.gabed.emplacement-detailMateriel',
                     params: { id: props.row.dispositif.emplacementId,
                      idMateriel: props.row.id }}"
                     class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(materielTlpePerm.lecture)}">
          {{ props.row.code }}
        </router-link>
      </div>
      <div slot="descriptionTlpe" slot-scope="props">
        <b-tooltip :label="$t(getDescriptionTlpe(props.row.descriptionTlpe).libelle)"
          position="is-right">
          <p class="ellipsis">
            {{ $t(getDescriptionTlpe(props.row.descriptionTlpe).libelleCourt) }}
          </p>
        </b-tooltip>
      </div>
      <div slot="dispositif.adresse" slot-scope="props">
        {{ props.row.dispositif.adresse.adresse1 }}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtatMontage(props.row.etat)) }}
      </div>
      <div slot="format.libelle" slot-scope="props">
        {{ props.row.format ? props.row.format.libelle : '' }}
      </div>
      <div slot="dateMontage" slot-scope="props">
        {{ getDateMontage(props.row) }}
      </div>
      <div slot="dateDemontage" slot-scope="props">
        {{ getDateDemontage(props.row) }}
      </div>
      <div slot="nbFacesMontees" slot-scope="props" class="level">
        <div class="level-left">
        {{ getnbFacesActifs(props.row) }}
        </div>
        <div class="level-right">
          <qd-button class="button pointer" size="is-small"
            @click="detailFaceClick(props.row)"
            :disabled="props.row.faces.length === 0"
            :class="{'is-primary': props.row.faces.length !== 0}"
            icon-left="text-box-multiple-outline"/>
        </div>
      </div>
      <div slot="type.libelle" slot-scope="props">
        {{ props.row.type ? props.row.type.libelle : '' }}
      </div>
      <div slot="dispositif.dispositifType.libelle" slot-scope="props">
        {{ props.row.dispositif ?
        getDispositifTypeLibelle(props.row.dispositif.dispositifTypeId) : '' }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.dispositif.emplacement.agenceId) }}
      </div>
      <div slot="dispositif.dispositifSupport.libelle" slot-scope="props">
        {{ props.row.dispositif && props.row.dispositif.dispositifSupport ?
        props.row.dispositif.dispositifSupport.libelle : '' }}
      </div>
      <div slot="etatMontageTlpe" slot-scope="props">
        {{ $t(getLibelleEtatTlpe(props.row.etatMontageTlpe)) }}
      </div>
      <div slot="surfaceTlpeDeclarable" slot-scope="props">
        <div class="is-pulled-right">
        {{ props.row.surfaceTlpeDeclarable }}
        </div>
      </div>
      <div slot="etatDemontageTlpe" slot-scope="props">
        {{ $t(getLibelleEtatTlpe(props.row.etatDemontageTlpe)) }}
      </div>
      <div slot="declarableEnMairie" slot-scope="props">
        <qd-checkbox class="mgl-10px" disabled :value="props.row.declarableEnMairie"/>
      </div>
      <div slot="numerique" slot-scope="props">
        <qd-checkbox class="mgl-10px" disabled :value="props.row.numerique"/>
      </div>
      <div slot="eclaire" slot-scope="props">
        <qd-checkbox class="mgl-10px" disabled :value="props.row.eclaire"/>
      </div>
      <div slot="dispositif.tiers.nomCommercial" slot-scope="props">
        {{ props.row.dispositif && props.row.dispositif.tiers ?
        props.row.dispositif.tiers.nomCommercial : '' }}
      </div>
      <div slot="actif" slot-scope="props">
        {{ props.row.actif ? $t('general.non') : $t('general.oui') }}
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-materiel @toggleFiltre="setShowFiltre" ref="filtreListeMaterielTlpe"
                            @recherche="makeRechercheFilter"
                            :critereRecherche="criteresRecherche"/>
      </div>
    </transition>
    <b-modal v-model="displayPopupUpdateTlpe" has-modal-card class="modal">
      <popup-update-tlpe-infos @updateMateriel="updateMateriel" />
    </b-modal>
    <b-modal v-model="displayPopupFaces" has-modal-card class="modal">
      <popup-liste-faces :materiel="selectedMateriel" />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { MATERIEL_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import filtreListeMateriel from '@/components/gabed/materiel/filtreListeMaterielTlpe';
import { SET_CRITERE } from '@/store/modules/gabed/materiel-mutation-type';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatIsoDate from '@/services/general/formatIsoDate';
import formatDate from '@/services/general/formatDate';
import { columnsSplice } from '@/services/general/columns';
import selecteurAction from '@/components/general/selecteurAction';
import { LISTE_ETAT_FIL_DE_LEAU } from '@/configuration/gabed/materiel/materielConf';
import { ACTION_EDIT_MATERIEL_TLPE, LISTE_DESCRIPTION_TLPE } from '@/configuration/gabed/tlpe/tlpeConf';
import popupUpdateTlpeInfos from '@/components/gabed/materiel/popupUpdateTlpeInfos';
import { updateTlpeFields } from '@/api/gabed/materiel';
import popupListeFaces from '@/components/gabed/materiel/popupListeFaces';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_MATERIELS_TLPE } from '@/configuration/general/referenceTableConf';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';

const Permissions = createNamespacedHelpers('permissions');
const Materiel = createNamespacedHelpers('materielTlpe');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  props: {
    collectiviteId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selectedMateriel: null,
      materielTlpePerm: MATERIEL_TLPE,
      unsubscribeValue: null,
      showFiltre: false,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      displayPopupUpdateTlpe: false,
      displayPopupFaces: false,
      actions: [
        { action: ACTION_EDIT_MATERIEL_TLPE, translation: 'listeMaterielTlpe.actions.editMaterielTlpe' },
      ],
      referenceTable: REFERENCE_TABLE_MATERIELS_TLPE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
  components: {
    TableItemsInView,
    filtreListeMateriel,
    selecteurAction,
    popupUpdateTlpeInfos,
    popupListeFaces,
    parametrageTable,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
      lockMenu: 'lockMenu',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Materiel.mapGetters({
      materiels: 'items',
      total: 'totalCount',
      criteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    getFilteredNumber() {
      const banCritere = ['auto', 'confrere', 'actif'];
      if (this.societeActive.agences.length === 1) banCritere.push('agencesId');
      let nbFiltre = calculNombreCritere(this.criteresRecherche, banCritere);
      nbFiltre += this.criteresRecherche.confrere !== null ? 1 : 0;
      nbFiltre += this.criteresRecherche.actif !== null ? 1 : 0;
      if (nbFiltre > 9) return '9+';
      return nbFiltre;
    },
    hasSelectedItems() {
      return this.materiels.some(item => item.selected)
        && this.checkPermissions(this.materielTlpePerm.maj);
    },
    hasAllLinesSelected() {
      return this.materiels.length > 0
        && !this.materiels.some(item => !item.selected);
    },
    columns() {
      const columns = [
        'selected',
        'code',
        'type.libelle',
        'descriptionTlpe',
        'disposition',
        'nbFacesMontees',
        'dispositif.adresse',
        'dispositif.adresse.ville',
        'etat',
        'dateMontage',
        'dateDemontage',
        'format.libelle',
        'surfaceTlpeDeclarable',
        'collectivite.nomCommercial',
        'typeTaxationTlpe.libelle',
        'etatMontageTlpe',
        'etatDemontageTlpe',
        'eclaire',
        'declarableEnMairie',
        'numerique',
        'agence',
        'dispositif.dispositifType.libelle',
        'dispositif.dispositifSupport.libelle',
        'dispositif.tiers.nomCommercial',
        'actif',
      ];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeMaterielTlpe.tab.code'),
          'dispositif.adresse.ville': this.$i18n.t('listeMaterielTlpe.tab.ville'),
          disposition: this.$i18n.t('listeMaterielTlpe.tab.disposition'),
          'format.libelle': this.$i18n.t('listeMaterielTlpe.tab.format'),
          'type.libelle': this.$i18n.t('listeMaterielTlpe.tab.typeMateriel'),
          'dispositif.dispositifType.libelle': this.$i18n.t('listeMaterielTlpe.tab.typeDispositif'),
          'dispositif.dispositifSupport.libelle': this.$i18n.t('listeMaterielTlpe.tab.support'),
          etat: this.$i18n.t('listeMaterielTlpe.tab.etat'),
          'dispositif.adresse': this.$i18n.t('listeMaterielTlpe.tab.adresse'),
          agence: this.$i18n.t('listeMaterielTlpe.tab.agence'),
          dateMontage: this.$i18n.t('listeMaterielTlpe.tab.dateMontage'),
          dateDemontage: this.$i18n.t('listeMaterielTlpe.tab.dateDemontage'),
          surfaceTlpeDeclarable: this.$i18n.t('listeMaterielTlpe.tab.surface'),
          'collectivite.nomCommercial': this.$i18n.t('listeMaterielTlpe.tab.collectivite'),
          'typeTaxationTlpe.libelle': this.$i18n.t('listeMaterielTlpe.tab.typeTaxation'),
          etatMontageTlpe: this.$i18n.t('listeMaterielTlpe.tab.etatMontageTlpe'),
          etatDemontageTlpe: this.$i18n.t('listeMaterielTlpe.tab.etatDemontageTlpe'),
          declarableEnMairie: this.$i18n.t('listeMaterielTlpe.tab.declarable'),
          numerique: this.$i18n.t('listeMaterielTlpe.tab.numerique'),
          nbFacesMontees: this.$i18n.t('listeMaterielTlpe.tab.nbFacesMontees'),
          eclaire: this.$i18n.t('listeMaterielTlpe.tab.eclairage'),
          'dispositif.tiers.nomCommercial': this.$i18n.t('listeMaterielTlpe.tab.confrere'),
          descriptionTlpe: this.$i18n.t('listeMaterielTlpe.tab.descriptionTlpe'),
          actif: this.$i18n.t('listeMaterielTlpe.tab.archive'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.hasAllLinesSelected;
                    this.materiels.forEach(item => { item.selected = !allSelected; });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal(),
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          if (this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          data.query = cloneDeep(this.criteresRecherche);
          if (data.query.datesMontage) {
            data.query.datesMontage.dateDebut = formatIsoDate(data.query.datesMontage.dateDebut);
            data.query.datesMontage.dateFin = formatIsoDate(data.query.datesMontage.dateFin);
          }
          if (data.query.datesDemontage) {
            data.query.datesDemontage.dateDebut = formatIsoDate(
              data.query.datesDemontage.dateDebut,
            );
            data.query.datesDemontage.dateFin = formatIsoDate(data.query.datesDemontage.dateFin);
          }
          if (data.query.sansDateMontage) {
            data.query.datesMontage = null;
          }
          if (data.query.sansDateDemontage) {
            data.query.datesDemontage = null;
          }
          if (data.query.sansCollectivite) data.query.collectivite = [];
          if (data.query.sansTypeTaxation) data.query.typeTaxation = [];
          data.query.societeId = this.societeActiveId;
          return this.loadMateriels(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.materiels,
            count: this.total,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: [
          'code',
          'dispositif.adresse.ville',
          'dispositif.adresse',
          'type.libelle',
          'etat',
          'dateMontage',
          'dateDemontage',
          'surfaceTlpeDeclarable',
          'collectivite.nomCommercial',
          'typeTaxationTlpe.libelle',
          'etatMontageTlpe',
          'etatDemontageTlpe',
          'declarableEnMairie',
          'numerique',
          'agence',
          'format.libelle',
          'dispositif.dispositifType.libelle',
          'dispositif.dispositifSupport.libelle',
          'disposition',
          'eclaire',
        ],
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Materiel.mapActions({
      loadMateriels: 'loadMateriels',
    }),
    ...Materiel.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    updateAgenceAndRecherche() {
      this.criteresRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      this.recherche();
    },
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    makeRechercheFilter(critereUpdate) {
      this.setCritereRecherche(critereUpdate);
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeMaterielTlpe.initializeFiltre();
      this.$refs.filtreListeMaterielTlpe.viderCritere();
      this.$refs.filtreListeMaterielTlpe.appliquerCritere();
      this.showFiltre = false;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeMaterielTlpe.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getDispositifTypeLibelle(id) {
      const dispositifFind = this.parametre(PARAMETRES_KEYS.dispositifType).find((dispositif) => {
        return dispositif.id === id;
      });
      return dispositifFind ? dispositifFind.libelle : '';
    },
    getEtatMontage(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
    getDescriptionTlpe(descriptionTlpe) {
      const descriptionFind = LISTE_DESCRIPTION_TLPE
        .find(el => el.code === descriptionTlpe);
      return descriptionFind;
    },
    getLibelleEtatTlpe(etat) {
      const etatFind = LISTE_ETAT_FIL_DE_LEAU
        .find(el => el.code === etat);
      return etatFind ? etatFind.libelle : '';
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    getDateMontage(row) {
      if (row === undefined || row === null || row.dateMontage === undefined
        || row.dateMontage === null) return '';
      return formatDate(row.dateMontage);
    },
    getDateDemontage(row) {
      if (row === undefined || row === null || row.dateDemontage === undefined
        || row.dateDemontage === null) return '';
      return formatDate(row.dateDemontage);
    },
    getnbFacesActifs(row) {
      const facesActives = row.faces.filter((face) => { return face.actif; });
      return facesActives ? facesActives.length : 0;
    },
    iconSelectTotal() {
      if (this.hasAllLinesSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    handleAction(action) {
      switch (action) {
        case ACTION_EDIT_MATERIEL_TLPE:
          this.displayPopupUpdateTlpe = true;
          break;
        default:
          break;
      }
    },
    getSelectedMaterielIds() {
      const selectedMateriels = [];
      this.materiels.forEach((materiel) => {
        if (materiel.selected) selectedMateriels.push(materiel);
      });
      return selectedMateriels.map((materiel) => {
        return materiel.id;
      });
    },
    async updateMateriel(args) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          materielIds: this.getSelectedMaterielIds(),
          TlpeFields: args,
        };
        await updateTlpeFields(params);
        this.startArrayRendering = true;
        this.mountedLoadingEnd = true;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }

      this.displayPopupUpdateTlpe = false;
      this.recherche();
    },
    detailFaceClick(row) {
      this.selectedMateriel = row;
      this.displayPopupFaces = !this.displayPopupFaces;
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.collectiviteId) this.criteresRecherche.collectiviteIds = [this.collectiviteId];
      await this.loadParametres([PARAMETRES_KEYS.dispositifType]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      this.criteresRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      if (this.moduleSecteurActive) {
        const targetSecteur = await getSecteursByIds(this.user.secteursId, PATRIMOINE);
        if (targetSecteur.length > 0) {
          this.criteresRecherche.secteurs = targetSecteur.map(ts => ts.id);
        }
      }
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
